import $ from "jquery";
/**
 * Define globally useful constants here
 * import individually to other files
 */
export const
  CLEAN_URL = `${window.location.origin}${window.location.pathname.replace(/\.html$/, '').replace(/\/$/, '')}`,
	$document = $(document),
	$window = $(window),
  $html = $('html'),
	$body = $('body');

export const Breakpoints = {
	X_SMALL: 500,
	MEDIUM: 640,
	X_MEDIUM: 800,
	LARGE: 1024,
	X_LARGE: 1200,
	XX_LARGE: 1440
};
